import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ContBtnLanguage, ContLanguage, ContGLobe, ContArrowLenguage } from './Language.styles';
import GlobeIcon from '../../assets/images/globe-icon.png';
import ExpandIcon from '../../assets/images/expand-lenguage-icon.png';
import {
  Popover,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { useLanguageContext } from '../../context/LanguageContext';

const Language = () => {
  const { i18n } = useTranslation();
  const anchorEl = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const { setLastLanguageChange } = useLanguageContext();

  const handleOpen = function () {
    setOpen(true);
  };

  const handleClose = function () {
    setOpen(false);
  };

  const handleChangeLanguage = (newLanguage) => {
    i18n.changeLanguage(newLanguage);
    setLastLanguageChange(false)
    handleClose();
  };

  const languageInitials = i18n.language === 'en' ? 'EN' : 'ES';

  return (
    <>
      <ContBtnLanguage onClick={handleOpen} ref={anchorEl}>
        <ContLanguage>
          <ContGLobe>
            <img src={GlobeIcon} alt={'Globe icon'} width={30} />
          </ContGLobe>
          <span>{languageInitials}</span>
          <ContArrowLenguage>
            <img src={ExpandIcon} alt={'arrow expand'} />
          </ContArrowLenguage>
        </ContLanguage>
      </ContBtnLanguage>

      <Popover
        anchorEl={anchorEl.current}
        anchorPosition={{ top: 20 }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        onClose={handleClose}
        open={isOpen}
      >
        <List disablePadding>
          <ListItem
            onClick={() => handleChangeLanguage('en')}
            style={{
              cursor: 'pointer',
              backgroundColor: i18n.language === 'en' ? '#f0f0f0' : 'transparent',
            }}
          >
            <ListItemText primary="English" />
          </ListItem>
          <ListItem
            onClick={() => handleChangeLanguage('es')}
            style={{
              cursor: 'pointer',
              backgroundColor: i18n.language === 'es' ? '#f0f0f0' : 'transparent',
            }}
          >
            <ListItemText primary="Español" />
          </ListItem>
        </List>

      </Popover>
    </>
  );
};

export default Language;
